import { parsePhoneNumber } from "libphonenumber-js";
import {
	CA_RECENT_BOOKINGS,
	CA_SITE_POPULAR_ARRIVAL,
	CA_SITE_POPULAR_DEPARTURE,
} from "../constants/Options";
import { caPopularDestination } from "../containers/redesign/homepage/constant";

export const CA_CONSTANT = {
	stripePublicKey: process.env.REACT_APP_STRIPE_PK_US,
	placesAutocompletedLocation: {
		lat: 45.424721,
		lng: -75.695,
	},
	addressCountry: "Canada",
	billingAddressSelectStates: "CA",
	getPaymentFrequency: "Bi-weekly",
	passportOrigin: "CA",
	bookingsEmail: "support@paylatertravel.ca",
	trustpilot: {
		locale: "en-CA",
		businessUnitID: "6023a4aac0f73e00011dcb3e",
		link: "https://www.trustpilot.com/review/paylatertravel.com",
	},
	homeflightMockup: "assets/images/paylaterflightswebusa.png",
	countryCode: "1",
	currencyCode: "CAD",
	supportMail: "support@paylatertravel.ca",
	formikMuiDateFormat: "YYYY-MM-DD",
	cardRental: "https://www.gotrentalcars.com/us-label/?agence_id=5890",
	gaMeasurementId: "G-P3RJJR6Z0Z",
	popularDestination: caPopularDestination,
	popularDepartureDestination: CA_SITE_POPULAR_DEPARTURE,
	popularArrivalDestination: CA_SITE_POPULAR_ARRIVAL,
	dateOfBirthExample: "1997-12-30",
	phoneInputCountryCode: "CA",
	formatPhoneNumber: (phoneNumber) => {
		try {
			const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
			return parsedPhoneNumber.formatInternational();
		} catch (_) {
			return phoneNumber;
		}
	},
	footerBrands: "/assets/redesign/icons/footer_stripe-us.svg",
};
